<style lang="stylus">
@import '../../../stylesheet/view/card.styl'
@import '../../../stylesheet/variable.styl'
.preorder-card-list
    padding 50px 0 50px
    min-height 100vh
    background-color rgb(255,255,255)
    header::after
        display none
    .no-cards
        padding-top 145px
        width 100%
        img
            display: block
            margin 0 auto
            width 95px
            height 95px
        .message
            margin 11px 0 20px 0
            font-size 14px
            width 100%
            text-align center
            color rgb(189, 192, 197)
        .to-binding-card
            border 1px solid rgb(255,95,22)
            color rgb(255,95,22)
            border-radius 3px
            width 150px
            height 33px
            line-height 33px
            text-align center
            font-size 14px
            margin 0 auto
    .has-cards
        padding-top 10px
        .select-tips
            min-height 44px
            background #fff
            display flex
            align-items center
            font-size 14px
            color #191A1B
            font-weight 500
            border-top 1px solid #ededed
            box-sizing border-box
            padding 12px 15px
            span
                color #C03131
        .selected-tips
          background url('../../../image/card/tips-bg.png') no-repeat
          background-size 100% 100%
          margin 0 10px 15px
          height 40px
          display flex
          align-items center
          img
              width 20px
              height 20px
              margin-left 20px
          div
              margin-left 10px
              color #634509
              font-size 15px
              span
                  color #EE5A61
        .card-item
            display flex
            align-items center
            margin 0 15px 0
            position relative
            .addon
                width 55px
                height 71px
                position absolute
                z-index 1
                padding 23px 15px
                top 0px
                right 0px
                text-align right
                img
                    height 26px
                    width 26px
                    border-radius 50%
        .page-infinite-loading
            height 50px
            line-height 50px
            vertical-align: middle
            div
                margin 0 auto
        .discount
            background-color #fff
            position fixed
            bottom 0px
            width 100%
            font-size 15px
            z-index 2
            &:after
                setTopLine(rgb(234,234,234))
                right 95px
            .show-detail
                float left
                height: 50px
                line-height: 50px
                i
                    float left
                    margin-left 15px
                & > span
                    margin-left 7px
                    font-size 13px
                    color rgb(121,125,130)
            .has-discount
                color rgb(255,95,22)
                font-size 15px
                float right
                display flex
                flex-direction column
                justify-content: center
                height 50px
                span
                    line-height auto
                .preorder-deduction
                    & > span:nth-child(1)
                        color rgb(25,26,27)
                        font-size 13px
                    & > span:nth-child(2)
                        margin-left 5px
                        font-size 12px
                        transform translate(0px, 2px) scale(0.8)
                    & > span:nth-child(3)
                        margin-left 0
                .preorder-card-consume
                    font-size 10px
                    color rgb(175, 179, 184)
            .to-pay
                margin-left 15px
                width 95px
                background-color rgb(255,95,22)
                color #fff
                text-align center
                float right
                height 50px
                line-height 50px
</style>
<template>
  <div class="preorder-card-list">
    <my-header :showHome="false" showBack>
      <!-- <div slot="title">券包</div> -->
      <div slot="right" color="rgb(255,95,22)" @click="addCard" v-if="hasCards">
        <img :src="require('../../../image/address/iconPlus.png')" alt="" style="width:16px;height:16px" />
      </div>
    </my-header>
    <div class="no-cards" v-if="!hasCards">
      <img src="../../../image/card/rectangle.png" alt="" />
      <div class="message">{{ `你还没有${cardName}哦～` }}</div>
      <div class="to-binding-card" @click="addCard">激活新券</div>
    </div>
    <div class="has-cards" v-else>
      <!-- <div class="select-tips">
        <div v-if="!selectedCard || (selectedCard && !selectedCard.length)">请选择卖座券，会按勾选顺序抵扣</div>
        <div v-else>已选中{{ selectedCard.length }}张，共抵扣{{ totalDeductionValue | price2 }}元</div>
      </div> -->
      <!-- <div class="select-tips">
        <div>温馨提示：系统根据您选择的<span>积分券先后顺序</span>进行抵扣</div>
      </div> -->
      <div class="selected-tips">
        <img src="../../../image/card/tips-icon.png" alt="" />
        <div v-if="!selectedCard || (selectedCard && !selectedCard.length)">请选择卖座券，会按勾选顺序抵扣</div>
        <div v-else>
          已选择<span>{{ selectedCard.length }}</span
          >张，共抵扣<span>{{ totalDeductionValue | price2 }}</span
          >元
        </div>
      </div>
      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-immediate-check="true" infinite-scroll-distance="10">
        <div v-show="inited" class="card-item" v-for="card in cardList">
          <div class="addon checkButton" @click="chooseCard(card.cardNum)">
            <img v-if="card.isChoosed" src="../../../image/card/iconTock.png" />
            <img v-else-if="card.validFlag" src="../../../image/card/iconTick.png" />
          </div>
          <div class="card-info" @click="cardDetail(card)">
            <a-card :showType="cardShowType" :card="card" @change-select-count="changeSelectNum"></a-card>
          </div>
        </div>
      </div>
      <div v-show="loading" class="page-infinite-loading">
        <card-spinner type="fading-circle"></card-spinner>
      </div>
      <deduction-detail @hideDetail="hideDeductionDetail" :isShow="isShowDeductionDetail"></deduction-detail>
      <!-- <div class="discount">
                <div class="show-detail" v-show="false">
                <div class="show-detail" v-show="selectedCard && selectedCard.length" @click="showDeductionDetail()">
                      <icon size="15" color="rgb(121,125,130)" v-show="!isShowDeductionDetail">sousuo-paixujiantoushang</icon>
                      <icon size="15" color="rgb(121,125,130)" v-show="isShowDeductionDetail">sousuo-paixujiantouxia</icon>
                    <span>抵扣明细</span>
                </div>
                <div class="to-pay" @click="toPay">确认</div>
                <div class="has-discount">
                    <div class="preorder-deduction" v-show="!isShowDeductionDetail">
                        <span>抵扣</span>
                        <span>&yen;</span>
                        <span>{{totalDeductionValue | price2}}</span>
                    </div>
                    <div class="preorder-card-consume" v-show="false">
                    <div class="preorder-card-consume" v-show="showDeductionTotal">
                        <span>卡内消费</span>
                        <span v-if="totalCard.displayType !== CARD_TYPE_TIME_CARD && totalCard.displayType !== CARD_TYPE_GIFT_CARD">&yen;</span>
                        <span>{{totalCard | priceDeduction('totalDeductedRecharge', 'totalDeductedCount') | cardPriceFrist}}</span>
                        <span class="decimal">{{totalCard | priceDeduction('totalDeductedRecharge', 'totalDeductedCount') | cardPriceSecond}}</span>
                        <span class="unit">{{totalCard | priceDeduction('totalDeductedRecharge', 'totalDeductedCount') | cardPriceThird}}</span>
                    </div>
                </div>
            </div> -->
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { InfiniteScroll, spinner, MessageBox } from 'mint-ui'
import STATUS_CODE from '../../constant/status_code'
import RSA from '../../util/RSA.js'
import _ from 'underscore'
import myHeader from '../../components/header.vue'
import deductionDetail from '../../components/deduction_detail.vue'
import icon from '../../components/icon.vue'
import aCard from './sub_view/a_card_view.vue'
import CONSTANT from '../../constant/card'
import op from 'object-path'
import theme from '../../theme'
import moment from 'moment'
import cookie from '../../lib/cookie.js'
import CONSTANT_COOKIE from '../../constant/cookie.js'
let rsa = new RSA()
export default {
  data() {
    return {
      CARD_TYPE_TIME_CARD: CONSTANT.CARD_TYPE_TIME_CARD,
      CARD_TYPE_VALUE_CARD: CONSTANT.CARD_TYPE_VALUE_CARD,
      CARD_TYPE_SUDA_CARD: CONSTANT.CARD_TYPE_SUDA_CARD,
      CARD_TYPE_GIFT_CARD: CONSTANT.CARD_TYPE_GIFT_CARD,
      loading: false,
      cardLoadSize: 5,
      isShowDeductionDetail: false,
      updateCard: 0,
      cardShowType: CONSTANT.CARD_DEDUCTION_CARD_LIST,
      inited: false,
      cardName: theme.get('CARD_NAME'),
      limitMsg: '',
    }
  },
  watch: {
    isLimitPay: {
      handler(newVal) {
        if (newVal) {
          this.limitMsg = this.$store.state.preorder.selectedCards.checkMsg
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      cardList: state => state.preorder.cardsList,
      couponList: state => op(state.preorder).get('selectedCoupon.epayList') || [],
      orderType: state => state.preorder.orderType,
      orderKey: state => state.preorder.orderKey,
      skuList: state => state.preorder.preorderSkuList,
      totalDeductionValue: state => op(state.preorder).get('selectedCards.deductionInfo.deductionValue') || 0,
      selectedCard: state => op(state.preorder).get('selectedCards.epayList'),
      matchCardNum: state => state.preorder.orderMatchCardNum,
      totalDeductedRecharge: state => op(state.preorder.selectedCards).get('deductionInfo.deductedRecharge') || 0,
      totalDeductedCount: state => op(state.preorder.selectedCards).get('deductionInfo.deductedCount') || 0,
      cardSelectedFromDetail: state => state.preorder.cardSelectedFromDetail,
      preorderId: state => state.preorder.preorderId,
      totalBalance: state => state.balance.totalBalance,
      endTime: state => state.preorder.filmData.endPayTime || 0, //订单的截止时间
      isLimitPay: state => !!op(state.preorder.selectedCards).get('limitPay'),
    }),

    hasCards() {
      if (this.matchCardNum == 0) {
        return false
      }
      return true
    },
    hasMixCard() {
      // 如果同时勾选了次卡和礼包卡
      return (
        this.selectedCard &&
        this.selectedCard.length &&
        this.selectedCard.some(card => op(card).get('extraInfo.displayType') == this.CARD_TYPE_TIME_CARD) &&
        this.selectedCard.some(card => op(card).get('extraInfo.displayType') == this.CARD_TYPE_GIFT_CARD)
      )
    },
    totalCard() {
      return {
        displayType: op(this.selectedCard).get('0.extraInfo.displayType'),
        totalDeductedCount: this.totalDeductedCount,
        totalDeductedRecharge: this.totalDeductedRecharge,
      }
    },
    showDeductionTotal() {
      return !this.isShowDeductionDetail && !this.hasMixCard && op(this.selectedCard).get('length')
    },
    couponUsedList() {
      return (
        _.map(this.couponList, coupon => {
          return {
            type: 1,
            content: rsa.encrypt(`${coupon.epayId}`, 'base64'),
          }
        }) || []
      )
    },
  },
  components: {
    'card-spinner': spinner,
    'my-header': myHeader,
    'deduction-detail': deductionDetail,
    icon,
    aCard,
  },
  async mounted() {
    if (this.orderKey == '' || this.orderType == 0 || this.skuList == []) {
      this.$router.go(-1)
      return
    }
    await this.initData()
    window.scrollTo(0, 0)
  },
  beforeRouteLeave(to, from, next) {
    const now = cookie(CONSTANT_COOKIE.COOKIE_SERVICE_TIME)
    if (this.isLimitPay && to.name === 'preorder' && !moment(moment.unix(this.endTime)).isBefore(moment.unix(now))) {
      this.$store.commit('rootApperError', this.limitMsg)
      next(false)
      return
    }
    next()
  },
  methods: {
    ...mapActions(['matchOrderCardList', 'orderCheckPay', 'getDesignatedCards', 'matchCardTotal']),
    async changeSelectNum({ cardNum, count }) {
      let self = this
      let cardUsedList = []
      const Num = cardNum
      // 在已选的卡中， 组装除当前卡之外的卡请求数据
      _.each(this.selectedCard, card => {
        if (card.epayNumber !== Num) {
          cardUsedList.push({
            type: 3,
            content: rsa.encrypt(card.epayId, 'base64'),
            selectCount: card.selectCount,
            isLastChange: 0,
          })
        }
      })
      // 在卡列表中找到当前卡的数据
      let currentCard = this.cardList.find(c => {
        return c.cardNum == Num || c.cardNum == op(self.cardSelectedFromDetail).get('cardNum')
      })

      // 组装当前卡请求数据
      cardUsedList.push({
        type: 3,
        content: rsa.encrypt(currentCard.uniqueCardId, 'base64'),
        selectCount: count,
        isLastChange: 1, // 1表示这张卡是最后勾选
      })
      // 组装请求数据
      let data = {
        preOrderId: this.preorderId,
        cardList: cardUsedList,
        couponList: this.couponUsedList,
        balance: this.totalBalance,
      }

      try {
        const { card } = await this.orderCheckPay(data)
      } catch (e) {
        if (op(e).get('checkMsg') == STATUS_CODE.PREORDER_ORDERCHECKPAY_CARD_ERROR) {
          this.$store.commit('rootApperError', op(e).get('card.checkMsg') || op(e).get('checkMsg'))
        } else if (op(e).get('checkMsg') == STATUS_CODE.PREORDER_ORDERCHECKPAY_COUPON_ERROR) {
          this.$store.commit('rootApperError', op(e).get('coupon.checkMsg') || op(e).get('checkMsg'))
        } else {
          this.$store.commit('rootApperError', op(e).get('checkMsg') || e.msg)
        }
        // }
      }
    },
    async initData() {
      let data = {
        pageNum: 1,
        pageSize: 5,
        preOrderId: this.preorderId,
      }
      this.matchCardTotal(data)
      this.inited = false
      await this.initSelectedCard(data)

      if (JSON.stringify(this.cardSelectedFromDetail) !== '{}') {
        await this.chooseCard(this.cardSelectedFromDetail.cardNum)
        this.$store.commit('selectCardFromDetail', {})
      }
      this.inited = true
    },
    async initSelectedCard(data) {
      let self = this
      this.loading = true
      await this.matchOrderCardList(data)
      self.cardLoadSize = self.cardLoadSize + 5

      // 拉取订单可用卡列表
      if (!_.isEmpty(self.selectedCard) || JSON.stringify(this.cardSelectedFromDetail) !== '{}') {
        let contentList = []

        _.each(self.selectedCard, card => {
          if (card.contentData) {
            contentList.push(card.contentData)
          } else {
            contentList.push({
              type: 3,
              content: rsa.encrypt(card.epayId, 'base64'),
            })
          }
        })

        if (JSON.stringify(this.cardSelectedFromDetail) !== '{}') {
          contentList.push({
            type: 3,
            content: rsa.encrypt(this.cardSelectedFromDetail.uniqueCardId, 'base64'),
          })
        }

        let queryData = {
          preOrderId: this.preorderId,
          cardList: contentList,
        }
        //校验卡是否可用于订单，并返回相关卡详情
        //用于场景： cardSelect中有该卡，但在当前CardList中还没有
        await self.getDesignatedCards(queryData)
      }
      self.loading = false
    },
    cardDetail(card) {
      card.bindFlag = 1
      this.$store.commit('setCardDetail', card)
      this.$router.push({
        path: `/preorder/card/detail/${card.cardNum}`,
        query: {
          preorder: 1,
        },
      })
    },
    toPay() {
      this.$router.go(-1)
    },
    async chooseCard(Num) {
      let self = this
      let cardUsedList = []
      _.each(this.selectedCard, card => {
        if (card.epayNumber !== Num) {
          cardUsedList.push({
            type: 3,
            content: rsa.encrypt(card.epayId, 'base64'),
            selectCount: card.selectCount,
            isLastChange: 0,
          })
        }
      })

      let currentCard = this.cardList.find(c => {
        return c.cardNum == Num || c.cardNum == op(self.cardSelectedFromDetail).get('cardNum')
      })
      if ((currentCard && Num && !currentCard.isChoosed) || (!Num && currentCard)) {
        //保证最后勾选的卡在数组最末
        cardUsedList.push({
          type: 3,
          content: rsa.encrypt(currentCard.uniqueCardId, 'base64'),
          selectCount: currentCard.selectCount,
          isLastChange: 1,
        })
      } else if (!currentCard && !Num) {
        this.$myToast('当前订单不能使用该券')
      }

      let data = {
        preOrderId: this.preorderId,
        cardList: cardUsedList,
        couponList: this.couponUsedList,
        balance: this.totalBalance,
      }

      try {
        const { card } = await this.orderCheckPay(data)
      } catch (e) {
        let statusCode = `${op(e).get('checkStatus')}&${op(e).get('card.checkStatus')}&${op(e).get('card.checkStatus')}&${op(e).get('status')}`
        let alertMsg = ''
        if (statusCode.includes(STATUS_CODE.PREORDER_ORDERCHECKPAY_FILMCARD_AND_COUPON_CANNOT_BOTH_USE)) {
          alertMsg = '当前商品不能同时使用现金券和电影券,是否使用电影券？'
          this.cardAndCouponMutex(alertMsg, Num)
        } else if (statusCode.includes(STATUS_CODE.PREORDER_ORDERCHECKPAY_GIFTCARD_AND_COUPON_CANNOT_BOTH_USE)) {
          alertMsg = '当前商品不能同时使用现金券和礼包券,是否使用礼包券？'
          this.cardAndCouponMutex(alertMsg, Num)
        } else if (statusCode.includes(STATUS_CODE.PREORDER_CARD_AND_COUPON_CANNOT_BOTH_USE)) {
          alertMsg = '当前商品不能同时使用现金券和卖座券，是否使用卖座券？'
          this.cardAndCouponMutex(alertMsg, Num)
        } else {
          if (op(e).get('checkMsg') == STATUS_CODE.PREORDER_ORDERCHECKPAY_CARD_ERROR) {
            this.$store.commit('rootApperError', op(e).get('card.checkMsg') || op(e).get('checkMsg'))
          } else if (op(e).get('checkMsg') == STATUS_CODE.PREORDER_ORDERCHECKPAY_COUPON_ERROR) {
            this.$store.commit('rootApperError', op(e).get('coupon.checkMsg') || op(e).get('checkMsg'))
          } else {
            this.$store.commit('rootApperError', op(e).get('checkMsg') || e.msg)
          }
        }
      }
    },
    async cardAndCouponMutex(alertMsg, Num) {
      let action = await MessageBox({
        message: alertMsg,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
      })
      if (action == 'cancel') {
        return
      }

      this.$store.commit('clearSelectedCoupons')
      this.chooseCard(Num)
    },
    addCard() {
      this.$router.push({
        name: 'preorderCardQuery',
        query: {
          preorder: 1,
        },
      })
    },
    loadMore() {
      if (this.cardList.length >= this.$store.state.preorder.orderMatchCardNum) {
        return
      }
      let data = {
        pageNum: 1,
        pageSize: this.cardLoadSize + 5,
        preOrderId: this.preorderId,
      }
      this.initSelectedCard(data)
    },
    showDeductionDetail() {
      return (this.isShowDeductionDetail = !this.isShowDeductionDetail)
    },
    hideDeductionDetail() {
      return (this.isShowDeductionDetail = false)
    },
  },
  directives: {
    InfiniteScroll,
  },
}
</script>
